import { Competition } from 'business';
import { useBatchedQuery } from 'bridge';

export default function useBookedCompetitions(userId?: string) : [Competition[] | undefined, () => void]  {
    const [bookedCompetitions, onLoadMoreBookedCompetitions] = useBatchedQuery<Competition>({ userId: userId, queryType: 'bookedCompetitions'});
    return [bookedCompetitions, onLoadMoreBookedCompetitions];
}
